import axios, { type AxiosError } from "axios";

import { m } from "@vega-core/paraglide/messages";
import { getBaseURL } from "@vega-core/utils/global";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { apiErrorInterceptor } from "./interceptors/apiErrorInterceptor";
import { authInterceptor } from "./interceptors/authInterceptor";
import { errorInterceptor } from "./interceptors/errorInterceptor";
import { headersInterceptor } from "./interceptors/headersInterceptor";
import { createRetryInterceptor } from "./interceptors/retryInterceptor";

export type ResponseError = { message: string[] };

export function formatKnownError(error: AxiosError<ResponseError>) {
  const knownError = error.response?.data.message[0];

  return isTruthy(knownError) ? knownError : m.formValidation_unexpectedError();
}

const axiosConfig = {
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60_000,
  paramsSerializer: { indexes: null },
  withXSRFToken: true,
};

export const swaggerAxiosInstance = axios.create(axiosConfig);

swaggerAxiosInstance.interceptors.request.use(headersInterceptor, (error) =>
  Promise.reject(error),
);
swaggerAxiosInstance.interceptors.response.use(
  (response) => response,
  createRetryInterceptor(swaggerAxiosInstance),
);
swaggerAxiosInstance.interceptors.response.use(
  (response) => response,
  apiErrorInterceptor,
);
swaggerAxiosInstance.interceptors.response.use(
  (response) => response,
  errorInterceptor,
);
swaggerAxiosInstance.interceptors.request.use(authInterceptor, (error) =>
  Promise.reject(error),
);
